namespace Vit.Administration {
    export interface TenantForm {
        Id: Serenity.StringEditor;
        ParentTenantId: Serenity.LookupEditor;
        TenantName: Serenity.StringEditor;
    }

    export class TenantForm extends Serenity.PrefixedContext {
        static formKey = 'Administration.Tenant';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TenantForm.init) {
                TenantForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;

                Q.initFormType(TenantForm, [
                    'Id', w0,
                    'ParentTenantId', w1,
                    'TenantName', w0
                ]);
            }
        }
    }
}
